import { ButtonCall, ContainerHome, ContainerPage } from "./styles";

import { WhatsApp } from "../../components/WhatsApp";
import Header from "../../components/Header";
import { Contact } from "../../pages/Contact";
import { Footer } from "../../components/Footer";

export const Home = () => {
  return (
    <ContainerPage>
      <ContainerHome>
        <Header />
        <ButtonCall>
          <a
            id="whatsapp-button"
            href="https://api.whatsapp.com/send?phone=5521966405629"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button>CHAMAR ASSISTÊNCIA</button>
          </a>
        </ButtonCall>
        <WhatsApp />
      </ContainerHome>
      <Contact />
      <Footer />
    </ContainerPage>
  );
};
